import React, { CSSProperties } from "react";

export default function IconToolbox(props: {
	className?: string;
	style?: CSSProperties;
	color?: string;
	size?: number;
}) {
	return (
		<svg
			className={props.className}
			style={props.style}
			xmlns="http://www.w3.org/2000/svg"
			width={props.size ?? 24}
			height={props.size ?? 24}
			viewBox="0 0 24 24"
		>
			<path
				d="M7.5 6.63v.74H5.25A2.25 2.25 0 0 0 3 9.62v2.25h4.5v-.75a.75.75 0 0 1 1.5 0v.75h6v-.75a.75.75 0 1 1 1.5 0v.75H21V9.62a2.25 2.25 0 0 0-2.25-2.25H16.5v-.74a2.25 2.25 0 0 0-2.25-2.25h-4.5A2.25 2.25 0 0 0 7.5 6.63m2.25-.75h4.5a.75.75 0 0 1 .75.75v.74H9v-.74a.75.75 0 0 1 .75-.75M21 13.38h-4.5v1.24a.75.75 0 0 1-1.5 0v-1.25H9v1.25a.75.75 0 0 1-1.5 0v-1.25H3v4a2.25 2.25 0 0 0 2.25 2.25h13.5A2.25 2.25 0 0 0 21 17.37z"
				fill={props.color ?? "black"}
			/>
		</svg>
	);
}
